import * as yup from 'yup';


const schema = {
  imagePermission: yup.string().default('').nullable().required('This field is required.'),
  tosAccept: yup.boolean().oneOf([true], 'This field must be checked')
};

export default schema;